import { hdrm, view } from '@yola/ws-sdk';
import store from 'src/js/store';

const { getClosestSelectableElement } = hdrm.helpers;

const selectClosestSelectableParent = (element) => {
  const state = store.getState();
  // Only `blurFocusedElement` synchronizes the live element back to the static one,
  // so plain `setFocusedElement(null)` would drop edits made inside the block.
  if (view.selectors.getFocusedElement(state)) {
    store.dispatch(view.actions.blurFocusedElement({ preserveFocusedTextElement: true }));
  }

  const selectableParent = getClosestSelectableElement(element);

  if (!selectableParent) {
    return false;
  }

  const parentId = view.accessors.getLiveElementId(selectableParent);
  view.operations.setSelectedElement(parentId, { forced: true });
  view.operations.setHoveredElement(parentId);

  return true;
};

export default selectClosestSelectableParent;
